import { ActiveCompany, SourceFilter } from "./types";

export const DEFAULT_COMPANY: ActiveCompany = {
  company_id: "",
  company_name: "Select Company",
  company_type: "Type",
};

export const DEFAULT_FILTER: SourceFilter = {
  level_1: null,
  level_2: null,
  level_3: null,
};

export const SOURCE_TYPES = {
  ALL: "all",
  FACEBOOK: "facebook",
  WHATSAPP: "whatsapp",
  PUBLIC_FORM: "public_form",
  CRM: "crm",
} as const;

export const ALL_FORMS_VALUE = "all";
export const ALL_FORMS_LABEL = "All Forms";

export const DEFAULT_PAGE_SIZE = 30;
export const MAX_PAGE_SIZE = 100;
